import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.PRIVILEGES_LIST, { params: payload }),
    getPrivilege: payload => axios.get(HTTP.PRIVILEGE, { params: payload }),
    addPrivilege: payload => axios.post(HTTP.PRIVILEGE, payload),
    updatePrivilege: payload => axios.put(HTTP.PRIVILEGE, payload),
    deletePrivilege: payload => axios.delete(HTTP.PRIVILEGE, { params: { id: payload } })
}
